/* script */















import { tl } from '../languages';

function trianglePositionToSV(pt, top, bottomLeft, bottomRight) {
	// 1. Calculate standard barycentric coordinates (u, v, w) using determinants
	const det = (bottomLeft.y - bottomRight.y) * (top.x - bottomRight.x) + 
				(bottomRight.x - bottomLeft.x) * (top.y - bottomRight.y);

	// Weights associated with each vertex
	let wColor = ((bottomLeft.y - bottomRight.y) * (pt.x - bottomRight.x) + 
				(bottomRight.x - bottomLeft.x) * (pt.y - bottomRight.y)) / det;
				
	let wBlack = ((bottomRight.y - top.y) * (pt.x - bottomRight.x) + 
				(top.x - bottomRight.x) * (pt.y - bottomRight.y)) / det;
				
	let wWhite = 1 - wColor - wBlack;

	// 2. Clamp weights to keep the resulting point strictly inside the triangle boundaries
	if (wColor < 0) wColor = 0;
	if (wBlack < 0) wBlack = 0;
	if (wWhite < 0) wWhite = 0;
	
	const sum = wColor + wBlack + wWhite;
	wColor /= sum;
	wBlack /= sum;
	wWhite /= sum;

	// 3. Map the clamped barycentric weights back to HSV (S and V)
	// From forward formula: wBlack = 1 - V  ==>  V = 1 - wBlack
	const v = 1 - wBlack;

	// Avoid division by zero at absolute black (v = 0)
	// From forward formula: wColor = S * V ==> S = wColor / V
	const s = v === 0 ? 0 : wColor / v;

	return { 
		s: Math.clamp(s, 0, 1), 
		v: Math.clamp(v, 0, 1) 
	};
}

const __vue_script__ = {
	name: 'color-picker-wheel',
	props: {
		width: Number,
		height: Number,
		rotate: Boolean,
		hsv: Object
	},
	data() {return {
		update: 0
	}},
	computed: {
		position() {
			this.update;
			let hsv = this.hsv;
			let triangle = this.$refs.triangle;
			let dimensions = [
				triangle ? triangle.clientWidth : 20,
				triangle ? triangle.clientHeight : 20
			];

			const {s, v} = hsv;
			const top   = { x: dimensions[0]/2, y: 0  };
			const left  = { x: 0,  y: dimensions[1] };
			const right = { x: dimensions[0], y: dimensions[1] };

			const w_color = s * v;
			const w_white = (1 - s) * v;
			const w_black = 1 - v;

			return {
				x: w_color * top.x + w_black * left.x + w_white * right.x,
				y: w_color * top.y + w_black * left.y + w_white * right.y,
			}
		}
	},
	methods: {
		pointerDown(e1, channel) {
			let main_ref = this.$refs.reference;
			let triangle = this.$refs.triangle;
			let bounding_box = main_ref.getBoundingClientRect();
			let onMove = (e2) => {
				let x = e2.clientX - bounding_box.x;
				let y = e2.clientY - bounding_box.y;
				let hsv = this.hsv;

				if (channel == 'hue') {
					let angle = Math.atan2(
						y - bounding_box.height/2,
						x - bounding_box.width/2,
					);
					let hue = Math.radToDeg(angle);
					hsv.h = (360 + 90 + hue) % 360;
				} else {
					const pos = new THREE.Vector2(x, y);
					if (this.rotate) {
						pos.rotateAround({x: bounding_box.width/2, y: bounding_box.height/2}, Math.degToRad(-this.hsv.h));
					}
					pos.y -= triangle.parentElement.offsetTop;
					pos.x -= triangle.parentElement.offsetLeft + triangle.offsetLeft;
					const top   = { x: triangle.clientWidth/2, y: 0  };
					const left  = { x: 0,  y: triangle.clientHeight };
					const right = { x: triangle.clientWidth, y: triangle.clientHeight };
					Object.assign(hsv, trianglePositionToSV(pos, top, left, right));

				}
				this.$emit('input', this.hsv);
			}
			let onUp = (e2) => {
				document.removeEventListener('pointermove', onMove);
				document.removeEventListener('pointerup', onUp);
			}
			document.addEventListener('pointermove', onMove);
			document.addEventListener('pointerup', onUp);
			onMove(e1);
		},
		tl,
	},
	mounted() {
		this.update++;
	}
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wheel_color_picker",
      style: {
        height: _vm.height + "px",
        "--size": _vm.height + "px",
        "--hue": _vm.hsv.h + "deg",
      },
      on: {
        pointerdown: function ($event) {
          return _vm.pointerDown($event, "hue")
        },
      },
    },
    [
      _c("div", { ref: "reference", staticClass: "wheel_color_picker--ring" }, [
        _c(
          "div",
          {
            staticClass: "wheel_color_picker--island",
            class: { rotate_with_hue: _vm.rotate },
            on: {
              pointerdown: function ($event) {
                $event.stopPropagation()
                return _vm.pointerDown($event, "triangle")
              },
            },
          },
          [
            _c("div", {
              ref: "triangle",
              staticClass: "wheel_color_picker--triangle",
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "wheel_color_picker--cursor",
              style: {
                left: "calc(7.5% + " + _vm.position.x + "px)",
                top: _vm.position.y + "px",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "wheel_color_picker--hue_cursor" }),
      ]),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-7840c5cf_0", { source: "\n.wheel_color_picker {\n\t\tposition: relative;\n\t\tmax-width: var(--size);\n\t\tmargin: auto;\n\t\ttouch-action: none;\n}\n.wheel_color_picker--ring {\n\t\tposition: relative;\n\t\tmargin: 5px;\n\t\theight: calc(100% - 10px);\n\t\twidth: calc(100% - 10px);\n\t\tborder-radius: 50%;\n\t\tbackground: conic-gradient(red, yellow, lime, cyan, blue, magenta, red);\n\t\t--ring-width: 16px;\n}\n.wheel_color_picker--island {\n\t\tposition: absolute;\n\t\tright: var(--ring-width);\n\t\tleft: var(--ring-width);\n\t\ttop: var(--ring-width);\n\t\tbottom: var(--ring-width);\n\t\tborder-radius: 50%;\n\t\tbackground-color: var(--color-ui);\n}\n.wheel_color_picker--island.rotate_with_hue {\n\t\trotate: var(--hue);\n}\n.wheel_color_picker--hue_cursor {\n\t\tposition: absolute;\n\t\tcursor: pointer;\n\t\theight: 0;\n\t\twidth: 0;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\tright: 50%;\n\t\tbottom: 50%;\n\t\ttransform: rotate(calc(var(--hue) - 90deg));\n}\n.wheel_color_picker--hue_cursor::before {\n\t\tborder-width: 8px;\n\t\tmargin-top: -8px;\n\t\tborder-color: var(--color-border);\n}\n.wheel_color_picker--hue_cursor::after {\n\t\tborder-width: 7px;\n\t\tmargin-top: -7px;\n\t\tborder-color: var(--color-light);\n}\n.wheel_color_picker--hue_cursor::before,\n\t.wheel_color_picker--hue_cursor::after {\n\t\tposition: absolute;\n\t\tcontent: \"\";\n\t\tmargin-left: calc((var(--size) - 42px) / 2);\n\t\twidth: calc(var(--ring-width));\n\t\tborder-style: solid;\n\t\tborder-top-color: transparent;\n\t\tborder-bottom-color: transparent;\n\t\tborder-radius: 3px;\n}\n.wheel_color_picker--cursor {\n\t\tposition: absolute;\n\t\tborder-radius: 6px;\n\t\theight: 10px;\n\t\twidth: 10px;\n\t\tborder: 1px solid var(--color-border);\n\t\tbackground: var(--color-light);\n\t\tcursor: pointer;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tz-index: 2;\n\t\tmargin: -5px;\n}\n.wheel_color_picker--triangle {\n\t\twidth: 85%;\n\t\theight: 74%;\n\t\tmargin: auto;\n\t\t--pct: 84%;\n\t\tbackground:\n\t\t\tlinear-gradient(to bottom, hsl(var(--hue), 100%, 50%) 0, transparent 100%),\n\t\t\tlinear-gradient(300deg, white 0, transparent 66.6%)\n\t\t\tblack;\n\t\tclip-path: polygon(50% 0%, 0% 99.8%, 100% 99.8%);\n}\n", map: {"version":3,"sources":["js\\texturing\\ColorPickerWheel.vue"],"names":[],"mappings":";AA4IA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AACA;AACA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,wBAAA;EACA,kBAAA;EACA,uEAAA;EACA,kBAAA;AACA;AACA;EACA,kBAAA;EACA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iCAAA;AACA;AACA;EACA,kBAAA;AACA;AACA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,2CAAA;AACA;AACA;EACA,iBAAA;EACA,gBAAA;EACA,iCAAA;AACA;AACA;EACA,iBAAA;EACA,gBAAA;EACA,gCAAA;AACA;AACA;;EAEA,kBAAA;EACA,WAAA;EACA,2CAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;EACA,kBAAA;AACA;AACA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,qCAAA;EACA,8BAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;AACA;AAEA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA;;;QAGA;EACA,gDAAA;AACA","file":"ColorPickerWheel.vue","sourcesContent":["<template>\r\n\t<div class=\"wheel_color_picker\" :style=\"{height: height + 'px', '--size': height + 'px', '--hue': hsv.h + 'deg'}\" @pointerdown=\"pointerDown($event, 'hue')\">\r\n\t\t<div class=\"wheel_color_picker--ring\" ref=\"reference\">\r\n\t\t\t<div class=\"wheel_color_picker--island\" :class=\"{rotate_with_hue: rotate}\" @pointerdown.stop=\"pointerDown($event, 'triangle')\">\r\n\t\t\t\t<div class=\"wheel_color_picker--triangle\" ref=\"triangle\"></div>\r\n\t\t\t\t<div class=\"wheel_color_picker--cursor\"\r\n\t\t\t\t\t:style=\"{left: `calc(7.5% + ${position.x}px)`, top: position.y + 'px'}\"\r\n\t\t\t\t></div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"wheel_color_picker--hue_cursor\"></div>\r\n\t\t</div>\r\n\t</div>\r\n</template>\r\n\r\n<script lang=\"js\">\r\nimport { tl } from '../languages';\r\n\r\nfunction trianglePositionToSV(pt, top, bottomLeft, bottomRight) {\r\n\t// 1. Calculate standard barycentric coordinates (u, v, w) using determinants\r\n\tconst det = (bottomLeft.y - bottomRight.y) * (top.x - bottomRight.x) + \r\n\t\t\t\t(bottomRight.x - bottomLeft.x) * (top.y - bottomRight.y);\r\n\r\n\t// Weights associated with each vertex\r\n\tlet wColor = ((bottomLeft.y - bottomRight.y) * (pt.x - bottomRight.x) + \r\n\t\t\t\t(bottomRight.x - bottomLeft.x) * (pt.y - bottomRight.y)) / det;\r\n\t\t\t\t\r\n\tlet wBlack = ((bottomRight.y - top.y) * (pt.x - bottomRight.x) + \r\n\t\t\t\t(top.x - bottomRight.x) * (pt.y - bottomRight.y)) / det;\r\n\t\t\t\t\r\n\tlet wWhite = 1 - wColor - wBlack;\r\n\r\n\t// 2. Clamp weights to keep the resulting point strictly inside the triangle boundaries\r\n\tif (wColor < 0) wColor = 0;\r\n\tif (wBlack < 0) wBlack = 0;\r\n\tif (wWhite < 0) wWhite = 0;\r\n\t\r\n\tconst sum = wColor + wBlack + wWhite;\r\n\twColor /= sum;\r\n\twBlack /= sum;\r\n\twWhite /= sum;\r\n\r\n\t// 3. Map the clamped barycentric weights back to HSV (S and V)\r\n\t// From forward formula: wBlack = 1 - V  ==>  V = 1 - wBlack\r\n\tconst v = 1 - wBlack;\r\n\r\n\t// Avoid division by zero at absolute black (v = 0)\r\n\t// From forward formula: wColor = S * V ==> S = wColor / V\r\n\tconst s = v === 0 ? 0 : wColor / v;\r\n\r\n\treturn { \r\n\t\ts: Math.clamp(s, 0, 1), \r\n\t\tv: Math.clamp(v, 0, 1) \r\n\t};\r\n}\r\n\r\nexport default {\r\n\tname: 'color-picker-wheel',\r\n\tprops: {\r\n\t\twidth: Number,\r\n\t\theight: Number,\r\n\t\trotate: Boolean,\r\n\t\thsv: Object\r\n\t},\r\n\tdata() {return {\r\n\t\tupdate: 0\r\n\t}},\r\n\tcomputed: {\r\n\t\tposition() {\r\n\t\t\tthis.update;\r\n\t\t\tlet hsv = this.hsv;\r\n\t\t\tlet triangle = this.$refs.triangle;\r\n\t\t\tlet dimensions = [\r\n\t\t\t\ttriangle ? triangle.clientWidth : 20,\r\n\t\t\t\ttriangle ? triangle.clientHeight : 20\r\n\t\t\t];\r\n\r\n\t\t\tconst {s, v} = hsv;\r\n\t\t\tconst top   = { x: dimensions[0]/2, y: 0  };\r\n\t\t\tconst left  = { x: 0,  y: dimensions[1] };\r\n\t\t\tconst right = { x: dimensions[0], y: dimensions[1] };\r\n\r\n\t\t\tconst w_color = s * v;\r\n\t\t\tconst w_white = (1 - s) * v;\r\n\t\t\tconst w_black = 1 - v;\r\n\r\n\t\t\treturn {\r\n\t\t\t\tx: w_color * top.x + w_black * left.x + w_white * right.x,\r\n\t\t\t\ty: w_color * top.y + w_black * left.y + w_white * right.y,\r\n\t\t\t}\r\n\t\t}\r\n\t},\r\n\tmethods: {\r\n\t\tpointerDown(e1, channel) {\r\n\t\t\tlet main_ref = this.$refs.reference;\r\n\t\t\tlet triangle = this.$refs.triangle;\r\n\t\t\tlet bounding_box = main_ref.getBoundingClientRect();\r\n\t\t\tlet onMove = (e2) => {\r\n\t\t\t\tlet x = e2.clientX - bounding_box.x;\r\n\t\t\t\tlet y = e2.clientY - bounding_box.y;\r\n\t\t\t\tlet hsv = this.hsv;\r\n\r\n\t\t\t\tif (channel == 'hue') {\r\n\t\t\t\t\tlet angle = Math.atan2(\r\n\t\t\t\t\t\ty - bounding_box.height/2,\r\n\t\t\t\t\t\tx - bounding_box.width/2,\r\n\t\t\t\t\t);\r\n\t\t\t\t\tlet hue = Math.radToDeg(angle);\r\n\t\t\t\t\thsv.h = (360 + 90 + hue) % 360;\r\n\t\t\t\t} else {\r\n\t\t\t\t\tconst pos = new THREE.Vector2(x, y);\r\n\t\t\t\t\tif (this.rotate) {\r\n\t\t\t\t\t\tpos.rotateAround({x: bounding_box.width/2, y: bounding_box.height/2}, Math.degToRad(-this.hsv.h));\r\n\t\t\t\t\t}\r\n\t\t\t\t\tpos.y -= triangle.parentElement.offsetTop;\r\n\t\t\t\t\tpos.x -= triangle.parentElement.offsetLeft + triangle.offsetLeft;\r\n\t\t\t\t\tconst top   = { x: triangle.clientWidth/2, y: 0  };\r\n\t\t\t\t\tconst left  = { x: 0,  y: triangle.clientHeight };\r\n\t\t\t\t\tconst right = { x: triangle.clientWidth, y: triangle.clientHeight };\r\n\t\t\t\t\tObject.assign(hsv, trianglePositionToSV(pos, top, left, right));\r\n\r\n\t\t\t\t}\r\n\t\t\t\tthis.$emit('input', this.hsv);\r\n\t\t\t}\r\n\t\t\tlet onUp = (e2) => {\r\n\t\t\t\tdocument.removeEventListener('pointermove', onMove);\r\n\t\t\t\tdocument.removeEventListener('pointerup', onUp);\r\n\t\t\t}\r\n\t\t\tdocument.addEventListener('pointermove', onMove);\r\n\t\t\tdocument.addEventListener('pointerup', onUp);\r\n\t\t\tonMove(e1);\r\n\t\t},\r\n\t\ttl,\r\n\t},\r\n\tmounted() {\r\n\t\tthis.update++;\r\n\t}\r\n}\r\n</script>\r\n\r\n<style>\r\n\t.wheel_color_picker {\r\n\t\tposition: relative;\r\n\t\tmax-width: var(--size);\r\n\t\tmargin: auto;\r\n\t\ttouch-action: none;\r\n\t}\r\n\t.wheel_color_picker--ring {\r\n\t\tposition: relative;\r\n\t\tmargin: 5px;\r\n\t\theight: calc(100% - 10px);\r\n\t\twidth: calc(100% - 10px);\r\n\t\tborder-radius: 50%;\r\n\t\tbackground: conic-gradient(red, yellow, lime, cyan, blue, magenta, red);\r\n\t\t--ring-width: 16px;\r\n\t}\r\n\t.wheel_color_picker--island {\r\n\t\tposition: absolute;\r\n\t\tright: var(--ring-width);\r\n\t\tleft: var(--ring-width);\r\n\t\ttop: var(--ring-width);\r\n\t\tbottom: var(--ring-width);\r\n\t\tborder-radius: 50%;\r\n\t\tbackground-color: var(--color-ui);\r\n\t}\r\n\t.wheel_color_picker--island.rotate_with_hue {\r\n\t\trotate: var(--hue);\r\n\t}\r\n\t.wheel_color_picker--hue_cursor {\r\n\t\tposition: absolute;\r\n\t\tcursor: pointer;\r\n\t\theight: 0;\r\n\t\twidth: 0;\r\n\t\ttop: 50%;\r\n\t\tleft: 50%;\r\n\t\tright: 50%;\r\n\t\tbottom: 50%;\r\n\t\ttransform: rotate(calc(var(--hue) - 90deg));\r\n\t}\r\n\t.wheel_color_picker--hue_cursor::before {\r\n\t\tborder-width: 8px;\r\n\t\tmargin-top: -8px;\r\n\t\tborder-color: var(--color-border);\r\n\t}\r\n\t.wheel_color_picker--hue_cursor::after {\r\n\t\tborder-width: 7px;\r\n\t\tmargin-top: -7px;\r\n\t\tborder-color: var(--color-light);\r\n\t}\r\n\t.wheel_color_picker--hue_cursor::before,\r\n\t.wheel_color_picker--hue_cursor::after {\r\n\t\tposition: absolute;\r\n\t\tcontent: \"\";\r\n\t\tmargin-left: calc((var(--size) - 42px) / 2);\r\n\t\twidth: calc(var(--ring-width));\r\n\t\tborder-style: solid;\r\n\t\tborder-top-color: transparent;\r\n\t\tborder-bottom-color: transparent;\r\n\t\tborder-radius: 3px;\r\n\t}\r\n\t.wheel_color_picker--cursor {\r\n\t\tposition: absolute;\r\n\t\tborder-radius: 6px;\r\n\t\theight: 10px;\r\n\t\twidth: 10px;\r\n\t\tborder: 1px solid var(--color-border);\r\n\t\tbackground: var(--color-light);\r\n\t\tcursor: pointer;\r\n\t\ttop: 0;\r\n\t\tleft: 0;\r\n\t\tz-index: 2;\r\n\t\tmargin: -5px;\r\n\t}\r\n\r\n    .wheel_color_picker--triangle {\r\n\t\twidth: 85%;\r\n\t\theight: 74%;\r\n\t\tmargin: auto;\r\n\t\t--pct: 84%;\r\n\t\tbackground:\r\n\t\t\tlinear-gradient(to bottom, hsl(var(--hue), 100%, 50%) 0, transparent 100%),\r\n\t\t\tlinear-gradient(300deg, white 0, transparent 66.6%)\r\n\t\t\tblack;\r\n\t\tclip-path: polygon(50% 0%, 0% 99.8%, 100% 99.8%);\r\n    }\r\n</style>"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "js\\texturing\\ColorPickerWheel.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__